export default {
  free: 'GRATIS',
  save: 'Ahorra {{amount}}',
};
